<template>
  <v-layout wrap v-if="device">
    <v-flex xs12>
      <m-card title="Detail Perangkat Instansi">
        <v-layout wrap>
          <v-flex xs12 sm7 md8>
            <v-list>
              <v-subheader class="title green--text">Identitas</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="No. Reg" :value="device.perangkat_id" />
              <m-list-tile-info label="Nama" :value="device.nama" />
              <m-list-tile-info label="Surel" :value="device.email" />
              <v-subheader class="title green--text">Alamat</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="Alamat" :value="device.alamat" />
            </v-list>
          </v-flex>
        </v-layout>
      </m-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      device: null
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("device/detail", this.$route.params.perangkat_id)
        .then(res => {
          this.page = res.data;
          this.device = res.data;
        })
        .catch(e => e);
    },
    close() {
      this.$router.push({
        name: "device"
      });
    }
  }
};
</script>
